<!-- simple title + subtitile arrangement -->
<div class="pclist-simple-item" [class.active]="active" (click)="toggleActive(index)">
  <div class="pclist-simple-item__title">{{ title }}</div>
  <div class="pclist-simple-item__subtitle">{{ subTitle }}</div>
</div>
